// extracted by mini-css-extract-plugin
export default {"loadcontainer":"App_loadcontainer__pqrY+"};